import ApiService from "@/services/api.service";

export const apiService = new ApiService();
